import { getLoginUinfo, logoutOnly } from '@m2h/common/utils';

class LoginClass {
  constructor() {}
  isLogin() {
    const loginUInfo = getLoginUinfo();
    if (!loginUInfo) return false;
    return Boolean(loginUInfo.userId && +loginUInfo.userId > 0);
  }
  getUserId() {
    const loginUInfo = getLoginUinfo();
    if (!loginUInfo) return false;
    return (+loginUInfo.userId > 0) ? loginUInfo.userId : 0;
  }
  getUserInfo() {
    return getLoginUinfo() || {};
  }
  eventOfLogin() {
    return 'eventOfLogin';
  }
  eventOfLogout() {
    return 'eventOfLogout';
  }
  logout(callback) {
    try {
      logoutOnly({
        success: () => {
          callback && callback({ success: true });
        },
        fail: () => {
          callback && callback({ success: false });
        }
      });
    } catch (e) {
      callback && callback({ success: false });
    }
  }
}

export default new LoginClass();
